<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'审核管理'},{name:'用户认证审核'}]" :title="'用户认证审核'" ref="breadcrumb"/> -->
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="待审核" name="1" v-if="authorities.indexOf('sys:permission:background:user:unAudit')!==-1"></el-tab-pane>
              <el-tab-pane label="审核记录" name="2" v-if="authorities.indexOf('sys:permission:background:user:audit')!==-1"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="left">
                    <div class="child" v-show="tab==='2'">
                        <span class="name">审核结果：</span>
                        <el-select v-model="sendInfoOne.reviewResult" placeholder="请选择" size="small" clearable>
                            <el-option
                                    v-for="item in reviewResultList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期：</span>
                        <el-date-picker style="width:250px"
                                size="small"
                                v-model="dateS"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                :default-time="['24:00:00','23:59:59']"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索：</span>
                        <el-select v-model="getSelect" size="small" clearable>
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <!-- 表格1 -->
            <el-table
                    v-show="tab==='1'"
                    :data="tableData"
                    header-row-class-name="header"
                    @sort-change="sortChange"
                    ref="table"
                    fit
                    :height="bHeight"
                    :header-cell-style="headerStyle"
                    v-loading="loading"
                element-loading-text="请求中......"
                    style="width: 100%">
                <el-table-column
                        prop="id"
                        show-overflow-tooltip
                        
                        label="申请ID">
                </el-table-column>
                <el-table-column
                        prop="userName"
                        show-overflow-tooltip
                        
                        label="账号">
                </el-table-column>
                <el-table-column
                        prop="realName"
                        show-overflow-tooltip
                        
                        label="姓名">
                </el-table-column>
                <el-table-column
                        prop="sourceName"
                        show-overflow-tooltip
                        
                        label="账号来源">
                </el-table-column>
                <el-table-column
                        prop="companyName"
                        show-overflow-tooltip
                        
                        width="300"
                        label="企业全称">
                </el-table-column>
                <el-table-column
                        prop="companyNum"
                        show-overflow-tooltip
                        
                        width="200"
                        label="统一社会信用代码">
                </el-table-column>
                <el-table-column
                        prop="userTypeName"
                        show-overflow-tooltip
                        
                        label="用户类型">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        show-overflow-tooltip
                        
                        sortable="custom"
                        width="150"
                        label="提交时间">
                </el-table-column>
                <el-table-column
				v-if="authorities.indexOf('sys:permission:background:user:unAudit:button:view')!=-1||authorities.indexOf('sys:permission:background:user:unAudit:button:audit')!=-1"
                        label="操作"
                        
                        width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain @click="check(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:user:unAudit:button:view')!=-1">
                            查看
                        </el-button>
                        <el-button size="small" type="primary" class="super" plain @click="audit(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:user:unAudit:button:audit')!=-1">
                            审核
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格2 -->
            <el-table
                    v-show="tab==='2'"
                    :data="tableData"
                    header-row-class-name="header"
                    @sort-change="sortChange"
                    ref="multipleTable"
                    fit
                    :height="bHeight"
                    :header-cell-style="headerStyle"
                    v-loading="loading"
                element-loading-text="请求中......"
                    style="width: 100%">
                <el-table-column
                        prop="id"
                        show-overflow-tooltip
                        
                        label="申请ID">
                </el-table-column>
                <el-table-column
                        prop="userName"
                        show-overflow-tooltip
                        
                        label="账号">
                </el-table-column>
                <el-table-column
                        prop="realName"
                        show-overflow-tooltip
                        
                        label="姓名">
                </el-table-column>
                <el-table-column
                        prop="sourceName"
                        show-overflow-tooltip
                        
                        label="账号来源">
                </el-table-column>
                <el-table-column
                        prop="companyName"
                        show-overflow-tooltip
                        
                        width="300"
                        label="企业全称">
                </el-table-column>
                <el-table-column
                        prop="companyNum"
                        show-overflow-tooltip
                        
                        width="200"
                        label="统一社会信用代码">
                </el-table-column>
                <el-table-column
                        prop="userTypeName"
                        show-overflow-tooltip
                        
                        label="用户类型">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        show-overflow-tooltip
                        
                        sortable="custom"
                        width="150"
                        label="提交时间">
                </el-table-column>
                <el-table-column
                        prop="auditAccount"
                        show-overflow-tooltip
                        
                        width="150"
                        label="审核账号">
                </el-table-column>
                <el-table-column
                        prop="updateTime"
                        show-overflow-tooltip
                        
                        sortable="custom"
                        width="150"
                        label="审核时间">
                </el-table-column>
                <el-table-column
                        prop="checkStatusName"
                        show-overflow-tooltip
                        
                        label="审核结果">
                </el-table-column>
                <el-table-column
				v-if="authorities.indexOf('sys:permission:background:user:audit:button:view')!=-1"
                        label="操作"
                        
                        width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain @click="check(scope.row)">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="sendInfoOne.currentPage"
                        :page-sizes="[5, 10, 15, 20]"
                        :page-size="sendInfoOne.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog

                    title="认证信息"
                    :visible.sync="dialogInfo"
                    :close-on-click-modal="false"
                    width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">账号信息</div>
                        <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{detail.userName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">账号类型：</div>
                            <div class="content">{{detail.userTypeName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{detail.realName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">邮箱：</div>
                            <div class="content">{{detail.email}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系地址：</div>
                            <div class="content">{{detail.contactAddress}}</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">认证信息</div>
                        <div class="child">
                            <div class="name">企业全称：</div>
                            <div class="content">{{detail.companyName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">统一社会信用代码：</div>
                            <div class="content">{{detail.companyNum}}</div>
                        </div>
                        <div class="child">
                            <div class="name">用户类型：</div>
                            <div class="content">{{detail.userTypeName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系人：</div>
                            <div class="content">{{detail.contact}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{detail.contactPhone}}</div>
                        </div>
                        <div class="child"
                             v-show="detail.userType=='BANK' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                            <div class="name">LOGO：</div>
                            <div class="content"><img class="logos" :src="detail.frontPath+detail.logoUrl"></div>
                        </div>
                        <div class="child" v-show="detail.userType=='BANK'">
                            <div class="name">银行名称：</div>
                            <div class="content">{{detail.abbreviation}}</div>
                        </div>
                        <div class="child" v-show="detail.userType=='BANK'">
                            <div class="name">官网链接：</div>
                            <div class="content">{{detail.websiteLink}}</div>
                        </div>
                        <div class="child"
                             v-show="detail.userType=='BANK' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                            <div class="name">{{detail.userType=='BANK'?'简介':'公司简介'}}：</div>
                            <div class="content">{{detail.remarks}}</div>
                        </div>
                        <div class="child"
                             v-show="detail.userType=='INSTITUTIONAL_INVESTOR' || detail.userType=='CORPORATE_CLIENTS' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                            <div class="name">{{detail.userType=='INSTITUTIONAL_INVESTOR'?'名片':'营业执照'}}：</div>
                            <div class="content"><img class="license"
                                                      :src="detail.frontPath+detail.attachmentUrl"></div>
                        </div>
                        <div class="child" v-show="detail.userType=='FINANCE_LEASING_COMPANY'">
                            <div class="name">分类：</div>
                            <div class="content">{{detail.classifyName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{detail.createTime}}</div>
                        </div>
                    </div>
                    <div class="boxChild" v-if="tab==='2'">
                        <div class="basisTitle">认证信息</div>
                        <div class="child">
                            <div class="name">审核结果：</div>
                            <div class="content">{{detail.checkStatusName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detail.auditAccount}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detail.updateTime}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detail.auditInstructions}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 审核 -->
            <el-dialog
                    title="审核"
                    :visible.sync="dialogAudit"
                    :before-close="cancel"
                    :close-on-click-modal="false"
                    width="27%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>审核说明：</div>
                        <el-radio-group v-model="sendInfoTwo.checkStatus">
                            <el-radio :label="item.value" v-for="(item,index) in reviewResultLists" :key="index">
                                {{item.name}}
                            </el-radio>
                        </el-radio-group>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.checkStatus']">
                        错误提示：{{errors['sendInfoTwo.checkStatus']}}
                    </div>
                    <div class="childTextarea">
                        <div class="name">描述：</div>
                        <div class="content">
                            <el-input type="textarea" v-model="sendInfoTwo.auditInstructions" show-word-limit
                                      maxlength="200" style="width:100%;"></el-input>
                        </div>
                    </div>
                    <div class="doubleBtn">
                        <el-button size="small" @click="cancel">取消</el-button>
                        <el-button type="primary" size="small" @click="submit">确定</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
    // import breadcrumb from '../../components/breadcrumb';

    export default {
        components: {
            // breadcrumb
        },
        data() {
            return {
              loading:false,
				authorities:JSON.parse(window.localStorage.getItem('authorities')),
                reviewResultList: [],//审核状态
                options: [{
                    value: '2',
                    label: '账号'
                }, {
                    value: '3',
                    label: '姓名'
                }],//检索下拉
                getSelect: '',//检索下拉的值
                getValue: '',//检索输入框的值
                dateS: [],//日期
                sendInfoOne: {
                    currentPage: 1,//页码
                    pageSize: 10,//条数
                    reviewResult: null,//审核结果
                    startTime: null,//开始时间
                    endTime: null,//结束时间
                    id: null,//申请id
                    userName: null,//账号
                    realName: null,//姓名
                    property: null,//排序字段
                    direction: null,//排序方式
                },//检索提交数据
                totalSize: null,//总跳数
                tab: '1',//选项卡
                tableData: [],//表格数据
                dialogInfo: false,//查看明细弹出层
                detail: {},//查看详情
                dialogAudit: false,//审核弹出层
                reviewResultLists: [],//弹出层审核结果数组
                sendInfoTwo: {
                    id: null,//id
                    checkStatus: null,//审核结果
                    auditInstructions: null,//说明
                },//审核提交数据
                bHeight: void 0
            }
        },
        computed: {
            errors() {
                return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
            },
        },
        vuerify: {
            'sendInfoTwo.checkStatus': {
                test: function () {
                    if (this.sendInfoTwo.checkStatus) {
                        return true;
                    } else {
                        return false;
                    }
                },
                message: '选择审核结果'
            },
        },
        methods: {
          onReset(){
              this.getSelect = '';//检索下拉的值
                this.getValue = '';//检索输入框的值
                this.dateS = [];//日期
                this.sendInfoOne.currentPage = 1;//页码
                this.sendInfoOne.pageSize = 20;//条数
                this.sendInfoOne.reviewResult = null;//审核结果
                this.sendInfoOne.startTime = null;//开始时间
                this.sendInfoOne.endTime = null;//结束时间
                this.sendInfoOne.id = null;//申请id
                this.sendInfoOne.userName = null;//账号
                this.sendInfoOne.realName = null;//姓名
                this.sendInfoOne.property = null;//排序字段
                this.sendInfoOne.direction = null;//排序方式
                this.tableData = null;
                if(this.$refs.multipleTable) this.$refs.multipleTable.clearSort()
                if(this.$refs.table) this.$refs.table.clearSort()
                this.getData()
          },
          doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
            // 切换选项啦
            changeTab: function (tab) {
                // const num = tab.name
                this.tab = tab.name
                this.getSelect = '';//检索下拉的值
                this.getValue = '';//检索输入框的值
                this.dateS = [];//日期
                this.sendInfoOne.currentPage = 1;//页码
                this.sendInfoOne.pageSize = 20;//条数
                this.sendInfoOne.reviewResult = null;//审核结果
                this.sendInfoOne.startTime = null;//开始时间
                this.sendInfoOne.endTime = null;//结束时间
                this.sendInfoOne.id = null;//申请id
                this.sendInfoOne.userName = null;//账号
                this.sendInfoOne.realName = null;//姓名
                this.sendInfoOne.property = null;//排序字段
                this.sendInfoOne.direction = null;//排序方式
                this.tableData = null;
                this.getData();
            },
            //表格排序事件
            sortChange: function ({column, prop, order}) {
                if (order == 'ascending') {
                    order = 'ASC';
                } else {
                    order = 'DESC';
                }
                this.sendInfoOne.property = prop;
                this.sendInfoOne.direction = order;
                this.getData();
            },
            //分页功能模块
            //切换每页显示条数
            handleSizeChange(val) {
                this.sendInfoOne.pageSize = val;
                this.getData();
            },
            //切换页码
            handleCurrentChange(val) {
                this.sendInfoOne.currentPage = val;
                this.getData();
            },
            //查看明细
            check (row) {
              this.$router.push({path: `/auditsManagement/user/detail/${this.tab}`, query: {id: row.id, index: '/auditsManagement/user'},param:{type:this.tab}})
              //  const {code,data,msg} = await this.$axiosz.get('backstage/sysUserReviewLog/' + row.id)
              //   if (code == 200) {
              //       this.detail = data;
              //       this.dialogInfo = true;
              //   } else {
              //       this.$alert(msg)
              //   }
            },
            //打开审核
            audit: function (row) {
                this.$vuerify.clear();
                this.sendInfoTwo.id = row.id;
                this.dialogAudit = true;
            },
            //取消按钮
            cancel: function () {
                this.dialogAudit = false;
                this.sendInfoTwo.id = null;//id
                this.sendInfoTwo.checkStatus = null;//审核结果
                this.sendInfoTwo.auditInstructions = null;//说明
            },
            //保存按钮
            async submit(){
                this.$vuerify.clear();
                if (this.$vuerify.check()) {
                    const {code,msg} = await this.$axiosz.put('backstage/sysUserReviewLog/status', this.$qs.stringify(this.sendInfoTwo))
                    if (code == 200) {
                            this.$message({
                                message: '审核成功！',
                                type: 'success'
                            });
                            this.dialogAudit = false;
                            this.getData();
                        } else {
                            this.$alert(msg)
                        }
                }
            },
            //获取数据
            async getData() {
              try{
                this.dateToConversion();
                if (this.getSelect == '1') { //申请id
                    this.sendInfoOne.id = this.getValue;
                } else if (this.getSelect == '2') { //账号
                    this.sendInfoOne.userName = this.getValue;
                } else { //姓名
                    this.sendInfoOne.realName = this.getValue;
                }
                this.loading = true
                let url = '';
                if (this.tab == 1) {
                    url = 'backstage/sysUserReviewLog';
                } else {
                    url = 'backstage/sysUserReviewLog/record';
                }
                const {code ,data,msg} = await this.$axiosz.get(url, {params: this.sendInfoOne})
                this.loading = false
                if (code == 200) {
                        this.tableData = data.content ||[];
                        this.totalSize = data.totalElements || 0;
                    } else {
                        this.$alert(msg)
                    }
              }catch(e){
                this.loading = false
              }
            },
            //日期转换
            dateToConversion:function(){
                if (this.dateS && this.dateS.length > 0) {
                    this.sendInfoOne.startTime = this.dateS[0];
                    this.sendInfoOne.endTime = this.dateS[1];
                } else {
                    this.sendInfoOne.startTime = '';
                    this.sendInfoOne.endTime = '';
                }
            },
            //获取字典 审核状态
            async getReviewResultList () {
                // const {code,data} = await this.$axiosz.get('backstage/sysDict/isShow/CHECK_STATUS')
                const {code,data} = await this.$axiosz.get('backstage/sysDict/auditOption')
                

                if (code == 200) {
                        this.reviewResultList = data; //搜索条件
                        this.reviewResultLists = data; //审核表单
                    }
            }
        },
        mounted() {
          const that = this
            that.getReviewResultList();
          // 待审核
          if(that.authorities.indexOf('sys:permission:background:user:unAudit')===-1){
            that.tab='2'
          }
          // 待审核 和审核记录存在一个
          if(that.authorities.indexOf('sys:permission:background:user:unAudit')!==-1||that.authorities.indexOf('sys:permission:background:user:audit')!==-1){
            that.getData();
          }
          let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
        }
    }
</script>

<style lang="scss" scoped>

</style>